"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = exports.BlankSpace = exports.MainContent = exports.Title = exports.ContentWrapper = exports.IconWrapper = exports.Wrapper = exports.Global = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  width: 0.6rem;\n  height: 0.6rem;\n  border: none;\n  background: none;\n  align-self: flex-start;\n  height: 1.5rem;\n  cursor: pointer;\n  :active,\n  :focus {\n    outline: none;\n  }\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: 0.5rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.5rem;\n  flex: 1 1 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: block; /* Must use in order for text-overflow: ellipsis working */\n  font-weight: 600;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 0;\n  height: 100%;\n  overflow: hidden; /* Must use to force the content not go outside */\n  margin-right: 1rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  width: 1.2rem;\n  height: 1.5rem;\n  border: none;\n  align-self: flex-start;\n  margin-right: 1rem;\n  svg {\n    width: 100%;\n    height: 100%;\n    fill: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  width: ", ";\n  background-color: ", ";\n  border-radius: 3px;\n  position: relative;\n  box-shadow: rgba(9, 30, 66, 0.31) 0px 0px 1px,\n    rgba(9, 30, 66, 0.3) 0px 8px 16px -8px;\n  color: ", ";\n  display: flex;\n  padding: 1rem;\n  animation: ", " ", "ms linear;\n  animation-fill-mode: forwards;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes slide-in-left {\n    0% {\n      opacity: 0;\n      transform: translate3d(-100%, 0, 0);\n    }\n    100% {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes slide-out-left {\n    0% {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(-100%, 0, 0);\n    }\n  }\n\n  @keyframes slide-in-right {\n    0% {\n      opacity: 0;\n      transform: translate3d(100%, 0, 0);\n    }\n    100% {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes slide-out-right {\n    0% {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(100%, 0, 0);\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Global = _styledComponents["default"].div(_templateObject());

exports.Global = Global;

var Wrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.width;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.animationName;
}, function (props) {
  return props.speed;
});

exports.Wrapper = Wrapper;

var IconWrapper = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.iconColor;
});

exports.IconWrapper = IconWrapper;

var ContentWrapper = _styledComponents["default"].div(_templateObject4());

exports.ContentWrapper = ContentWrapper;

var Title = _styledComponents["default"].span(_templateObject5());

exports.Title = Title;

var MainContent = _styledComponents["default"].div(_templateObject6());

exports.MainContent = MainContent;

var BlankSpace = _styledComponents["default"].div(_templateObject7());

exports.BlankSpace = BlankSpace;

var CloseButton = _styledComponents["default"].button(_templateObject8(), function (props) {
  return props.fontColor;
});

exports.CloseButton = CloseButton;